<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  emits: ['held'],
  data() {
    return {
      runId: null,
      employeeId: null,
      employeeName: '',
      reason: '',
      error: '',
    };
  },
  methods: {
    open(runId, employeeId, employeeName) {
      this.runId = runId;
      this.employeeId = employeeId;
      this.employeeName = employeeName || '';
      this.reason = '';
      this.error = '';
      this.$openModal('hrm_payroll_hold_modal');
    },
    async submit() {
      if (!this.reason.trim()) { this.error = 'Reason is required'; return; }
      this.setLoading(true);
      try {
        const res = await axios.post(`/hrms/payroll/${this.runId}/employees/${this.employeeId}/hold`, {
          reason: this.reason.trim(),
        });
        this.$swalToast(res.data.message || 'Employee put on hold.');
        this.$closeModal('hrm_payroll_hold_modal');
        this.$emit('held');
      } catch (error) {
        if (error.type === 'validation') this.error = error.errors?.reason?.[0] || 'Invalid reason';
        else this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>

<template>
  <div class="modal fade" id="hrm_payroll_hold_modal">
    <div class="modal-dialog modal-dialog-centered"><div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Hold Payroll <span v-if="employeeName" style="font-size:13px; color:#94a3b8; font-weight:500;">— {{ employeeName }}</span></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="ph-info">
          <i class="ti ti-alert-triangle me-1"></i>
          This employee's payroll will be marked on-hold (e.g. dispute or investigation).
        </div>
        <label class="ph-lbl">Reason <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="3" maxlength="500" v-model="reason" :class="{ 'is-invalid': error }" placeholder="Why is this payroll on hold?"></textarea>
        <div v-if="error" class="ph-err">{{ error }}</div>
      </div>
      <div class="modal-footer">
        <a href="javascript:void(0);" class="btn btn-light" data-bs-dismiss="modal">Cancel</a>
        <a href="javascript:void(0);" class="btn btn-danger" @click="submit">Put on Hold</a>
      </div>
    </div></div>
  </div>
</template>

<style scoped>
.ph-info { background:#fff7ed; border:1px solid #fed7aa; border-radius:10px; padding:11px 13px; font-size:12px; color:#9a3412; margin-bottom:14px; }
.ph-lbl { font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 5px; display: block; }
.ph-err { font-size: 11px; color: #dc2626; margin-top: 4px; }
.form-control { border-radius: 10px; border-color: #e2e8f0; font-size: 13.5px; }
.form-control:focus { border-color: #a5b4fc; box-shadow: 0 0 0 3px rgba(79,70,229,.1); }
</style>